
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import WrapSelectedNodesOperation from "models/audioEditor/sequencerOperation/WrapSelectedNodesOperation";
import StartMuteWrapSequencerNode from "models/audioEditor/sequencerNodes/StartMuteWrapSequencerNode";
import Utils from "models/helper/Utils";
import RSVP from "rsvp";

const WrapSelectedNodesWithMuteOperation = WrapSelectedNodesOperation.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        WrapSelectedNodesOperation.apply(this, [attributes, options]);
    },

    execute: function(startSequencerNodeToWrap, endSequencerNodeToWrap){
        // Mute wrap carries no external audio; it injects a zero-gain filter into wrapped nodes.
        const startMuteWrapSequencerNode = new StartMuteWrapSequencerNode({
            "audioSegment": Utils.getInstance().getPauseAudioSegment(null, 0, 0),
            "sequencer": this.getSequencer()
        });

        startSequencerNodeToWrap = startMuteWrapSequencerNode.getSelectableStartNodeWrappedIfApplicable(startSequencerNodeToWrap);
        endSequencerNodeToWrap = startMuteWrapSequencerNode.getSelectableEndNodeWrappedIfApplicable(endSequencerNodeToWrap);

        const nodesCreated = this.wrapSequencerNodes(startMuteWrapSequencerNode, startSequencerNodeToWrap, endSequencerNodeToWrap);
        if (!nodesCreated || !nodesCreated.startWrapSequencerNode || !nodesCreated.endWrapSequencerNode) {
            return;
        }

        this.getSequencer().getHistoryManagement().addCreateWrapWithMuteLog(
            startSequencerNodeToWrap,
            endSequencerNodeToWrap,
            nodesCreated.startWrapSequencerNode,
            nodesCreated.endWrapSequencerNode
        );
    },

    undo: function(sequencerOperationCreateWrapWithMuteLog){
        this.revertWrapNodeCreation(sequencerOperationCreateWrapWithMuteLog.getStartWrapMuteNode());
    },

    redo: function(sequencerOperationCreateWrapWithMuteLog){
        this.wrapSequencerNodes(
            sequencerOperationCreateWrapWithMuteLog.getStartWrapMuteNode(),
            sequencerOperationCreateWrapWithMuteLog.getStartSequencerNodeToWrap(),
            sequencerOperationCreateWrapWithMuteLog.getEndSequencerNodeToWrap()
        );
    }
});

export default WrapSelectedNodesWithMuteOperation;
